import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "enlargement-modal" }
const _hoisted_2 = { class: "enlargement-modal__image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!
  const _component_ClickWrapper = _resolveComponent("ClickWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "enlargement-modal__close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-times" })
    ]),
    _createVNode(_component_ClickWrapper, {
      class: "enlargement-modal__container",
      ref: "root"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ResponsiveImage, _normalizeProps(_guardReactiveProps(_ctx.componentProps)), null, 16)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}